<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="transfer-popup success-popup">
    <div class="main-title">
        הועברו בהצלחה
        <span class="number">{{ successCount }}</span>
        מתוך
        <span class="number">{{ total }}</span>
        הוראות קבע
    </div>
    <h2>{{ isMobile ? subTitleMobile : subTitle }}</h2>
    <ul class="debit-list">
        <li>
            <div class="check-wrapper">
                <span>בית העסק</span>
            </div>
            <span class="phone"> טלפון </span>

            <span class="sum"> סכום החיוב </span>
        </li>
        <li
            *ngFor="let transaction of transactions; let i = index"
            [ngClass]="{
                'fail-transfer': transaction.rowReturnCode != 0 && transaction.rowReturnCode != 11,
                'success-transfer': transaction.rowReturnCode == 0 || transaction.rowReturnCode == 11
            }"
        >
            <span class="name"
                >{{ transaction.merchantName }}
                <span [id]="'name' + i" *ngIf="transaction.merchantPhone" class="tooltip-pos">
                    <span
                        class="tool-tip-phone mob"
                        appTooltip
                        [tooltipText]="textTooltip(transaction)"
                        [tooltipHtmlParent]="'name' + i"
                    >
                    </span>
                </span>
            </span>
            <span class="phone-num">{{ transaction.merchantPhone }}</span>
            <span class="sum"> {{ transaction.amount }} {{ getSymbol(transaction.currency) }}</span>
        </li>
    </ul>
    <div class="button-wrapper">
        <a (click)="transferDirectDebits()" title="" class="brand-button red-button"><span>הבנתי</span></a>
    </div>
</div>
